import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCreateAccount = loadable(() => import(/* webpackChunkName: "content/createwedding-create-account" */ './CreateAccount'), 'CreateAccount');
